import BentoCards from './bento-cards';

export default BentoCards;
